import { getFieldMetadata } from '@shared/components/ScheduleEditor/hooks/getFieldMetadata';
import { FieldMetadata } from '@shared/components/ScheduleEditor/hooks/useScheduleFormState';
import { ScheduleEditorData } from '@shared/components/ScheduleEditor/types';
import { Flex, FormControl, InputV2, InputV2Props, styled, TextV2 } from '@withjoy/joykit';
import React from 'react';

const StyledTextArea = styled.textarea`
  width: 100%;
  resize: none;
  height: 100px;
  font-size: 14px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-family: inherit;
`;

type FormTextFieldProps = {
  fieldName: keyof ScheduleEditorData;
  state: ScheduleEditorData;
  setValue: (key: keyof ScheduleEditorData, value: string) => void;
  label?: string;
  meta: Record<keyof ScheduleEditorData, FieldMetadata>;
  textField?: boolean;
  maxLength?: number | null;
} & Omit<InputV2Props, 'value' | 'onChange'>;

export const FormTextField = (props: FormTextFieldProps) => {
  const { state, setValue, fieldName, textField, label, meta } = props;
  const metadata = getFieldMetadata(fieldName, meta);

  const value = (state[fieldName] as string) ?? '';
  const maxLength = props.maxLength === undefined ? 255 : props.maxLength;
  const length = value.length;

  return (
    <FormControl
      label={label && <TextV2 typographyVariant="label3">{label}</TextV2>}
      isInvalid={metadata.error}
    >
      <Flex
        flexDirection="column"
        gap="8px"
      >
        {textField ? (
          <StyledTextArea
            value={value}
            onChange={event => {
              if (maxLength === null || event.target.value.length <= maxLength) {
                setValue(fieldName, event.target.value);
              }
            }}
          />
        ) : (
          <InputV2
            value={value}
            onChange={event => {
              if (maxLength === null || event.target.value.length <= maxLength) {
                setValue(fieldName, event.target.value);
              }
            }}
          />
        )}
        {maxLength && (
          <TextV2
            textAlign="right"
            typographyVariant="label2"
          >
            {`${length} / ${maxLength}`}
          </TextV2>
        )}
      </Flex>
    </FormControl>
  );
};
